
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { languageMessages } from '@/i18n'
import { ServerConfig } from '@/config/server-config'
import { LangOption } from '@/config/langulage-config'
import SwitchLanguage from '@/components/base/SwitchLanguage.vue'
import UpdatePassword from '@/components/base/UpdatePassword.vue'
import VersionInfo from '@/components/base/VersionInfo.vue'
import TenantStatusBar from '@/components/TenantStatusBar/index.vue'
import Cookies from 'js-cookie'
import {
    clearActiveTenantSession,
    initializeActiveTenantSession,
    loadAddAccountUrl,
    loadLoginSessions,
    LoginSession,
    setActiveTenantSession,
    withActiveTenantSession
} from '@/utils/login-session'

@Component({
    components: {
        SwitchLanguage,
        VersionInfo,
        UpdatePassword,
        TenantStatusBar
    }
})
export default class StatusComponent extends Vue {
    languageMessages = languageMessages
    languageDialogVisible = false
    passwordDialogVisible = false
    versionDialogVisible = false
    tenantSessions: LoginSession[] = []

    get currentTenantCode() {
        const authInfo = this.$store.state.auth.authInfo
        return authInfo && authInfo.tenantCode
    }

    get currentTenantSessions() {
        // 会话列表只提供可切换账号，当前账号与顶部名称使用同一份登录信息。
        return this.tenantSessions.filter(Boolean).map(session => ({
            ...session,
            active: session.tenantCode === this.currentTenantCode
        }))
    }

    @Watch('currentTenantCode', { immediate: true })
    onCurrentTenantCodeChange(tenantCode: string) {
        if (!tenantCode) return
        initializeActiveTenantSession(tenantCode)
        this.loadTenantSessions()
    }

    get currentTenantLabel() {
        const authInfo = this.$store.state.auth.authInfo || {}
        return `${authInfo.tenantName || ''}（${authInfo.tenantCode || ''}）`
    }

    get language() {
        // return this.$store.getters.language
        return Cookies.get('language') ? Cookies.get('language') : 'zh'
    }

    get langTxt() {
        const target = LangOption.find(option => option.key === this.language)
        return target && target.value
    }

    get loginName() {
        const authInfo = this.$store.state.auth.authInfo
        return authInfo && authInfo.displayName
    }

    loadTenantSessions() {
        loadLoginSessions().then(sessions => this.tenantSessions = sessions || [])
            .catch(error => this.$message.error(error.message))
    }

    handleSessionCommand(command: string) {
        if (command === 'add-account') {
            loadAddAccountUrl().then(url => {
                if (!url) return
                clearActiveTenantSession()
                location.href = url
            }).catch(error => this.$message.error(error.message))
            return
        }
        if (command.indexOf('tenant:') !== 0) return
        const tenantCode = command.substring('tenant:'.length)
        if (this.currentTenantCode === tenantCode) return
        setActiveTenantSession(tenantCode)
        location.reload()
    }

    handleCommand(command) {
        switch (command) {
            case 'language': {
                this.languageDialogVisible = true
                break
            }

            case 'version': {
                this.versionDialogVisible = true
                break
            }

            case 'password': {
                this.passwordDialogVisible = true
                break
            }

            case 'logout': {
                this.handleLogout()
                break
            }
        }
    }

    onSelectLan(lang: string) {
        this.languageDialogVisible = false
        if (lang !== this.language) {
            // this.$i18n.locale = lang
            // this.$store.dispatch('setLanguage', lang)
            Cookies.set('language', lang)
            location.reload()
        }
    }

    onUpdatePassword() {
        this.passwordDialogVisible = false
    }

    onVersionConfirm() {
        this.versionDialogVisible = false
    }

    handleLogout() {
        this.$confirm(this.$t('nav.logout.tips') as string, this.$t('nav.logout.confirm') as string, {
            cancelButtonText: this.$t('common.btn.cancel') as string,
            confirmButtonText: this.$t('common.btn.confirm') as string,
            type: 'warning'
        }).then(action => {
            // console.log(action)
            location.href = withActiveTenantSession(`${ServerConfig.DinoUrl}/logout`)
        })
    }
}
